import { useQuery } from "react-query";
import dayjs from "dayjs";
import { AppConstant, KeyConstant } from "@/const";
import { RequestService } from "@/services";
import { PaginationType, RequestMode } from "@/types/common";

export type InternalRequestFilter = {
  id?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  applicationSendUid?: string;
  status?: string;
};

export type InternalRequestPayloadType = {
  paginationParam: Partial<PaginationType>;
  filter: InternalRequestFilter;
  mode: RequestMode;
};

const useRequestList = (props: InternalRequestPayloadType) => {
  const { paginationParam, filter } = props;
  const { page, size } = paginationParam || {};
  const { id, startDate, endDate, applicationSendUid, status } = filter || {};

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [KeyConstant.REACT_QUERY.getInternalRequest, page, size, filter],
    queryFn: () => {
      return RequestService.getRequest({
        internalF: props.mode === "internal",
        page: page || 1,
        size: size || AppConstant.DEFAULT_SIZE_PAGE,
        startDate: startDate ? dayjs(startDate)?.valueOf() : undefined,
        endDate: endDate ? dayjs(endDate)?.valueOf() : undefined,
        requestId: id,
        applicationSendUid: applicationSendUid === AppConstant.SELECT_ALL ? undefined : applicationSendUid || undefined,
        status: !Number.isNaN(Number(status)) ? Number(status) : undefined,
      });
    },
  });

  const { data: requestList, ...pagination } = data || {};

  return {
    requestList: requestList || [],
    pagination: (pagination as PaginationType) || {},
    isLoading,
    isError,
    refetch,
  };
};

export default useRequestList;
